import COUNTRIES from './countries.json';

export const getDialCodeFromCountryCode = (countryCode: string): string | undefined =>
  COUNTRIES[countryCode]?.toString();

export const defaultCountryCodeValues = [
  {
    name: 'Deutschland',
    dialCode: '49',
    countryCode: 'DE',
  },
  {
    name: 'Schweiz',
    dialCode: '41',
    countryCode: 'CH',
  },
  {
    name: 'Österreich',
    dialCode: '43',
    countryCode: 'AT',
  },
];
